const heroes = Array.from(document.querySelectorAll(".bux-hero--carousel"));

heroes.forEach((hero) => {
  let slides = Array.from(
    hero.querySelectorAll(".bux-hero--carousel .bux-hero__container")
  );
  let tabs = Array.from(
    hero.querySelectorAll(".bux-hero--carousel .bux-hero__tab")
  );
  let currentIndex = 0;
  const tablistNode = hero.querySelector('[role=tablist]');
  const nodes = hero.querySelectorAll('[role="tab"]');
  const liveRegionNode = hero.querySelector('.bux-hero__carousel-items');

  const showSlide = (index) => {
    slides[currentIndex].classList.remove("showing");
    tabs[currentIndex].classList.remove("bux-hero__tab--active");
    currentIndex = (index + slides.length) % slides.length;
    for (let i = 0; i < tabNodes.length; i++) {
      hideTabpanel(i);
    }
    tabs[currentIndex].removeAttribute('tabindex');
    slides[currentIndex].classList.add("showing");
    tabs[currentIndex].classList.add("bux-hero__tab--active");
    liveRegionNode.setAttribute("aria-live", "polite");
  }

  const showNextSlide = () => showSlide(currentIndex + 1);
  const showPrevSlide = () => showSlide(currentIndex - 1);

  const handleTabClick = (event) => {
    const clickedTab = event.target;
    if (clickedTab.classList.contains("bux-hero__tab")) {
      const clickedTabIndex = tabs.indexOf(clickedTab);
      showSlide(clickedTabIndex);
    }
  };
  
  const nextButton = hero.querySelector(".bux-hero__button--right");
  const prevButton = hero.querySelector(".bux-hero__button--left");
  const image = hero.querySelector(".bux-hero--carousel .showing .bux-hero__image");
  const tabContainer = hero.querySelector(
    ".bux-hero--carousel .bux-hero__tabs"
  );
  const buttons = Array.from(hero.querySelectorAll(".bux-hero__button"));

  nextButton.addEventListener("click", showNextSlide);
  prevButton.addEventListener("click", showPrevSlide);
  tabContainer.addEventListener("click", handleTabClick);
  
  buttons.forEach((button) => {
    const buttonHeight = button.getBoundingClientRect().height;
    button.style.top = `${
      (image.getBoundingClientRect().height - buttonHeight) / 2
    }px`;
  });
  
  // slide picker controls
  let tabNodes = [];
  let tabpanelNodes = [];
  
  const handleSlidepickerClick = (event) => {
    let index = tabNodes.indexOf(event.currentTarget);
    setSelectedTab(index, true);
  };

  const handleTabKeydown = (event) => {
    let flag = false;
  
    switch (event.key) {
      case 'ArrowRight':
        setSelectedToNextTab(true);
        flag = true;
        break;
  
      case 'ArrowLeft':
        setSelectedToPreviousTab(true);
        flag = true;
        break;
  
      case 'Home':
        setSelectedTab(0, true);
        flag = true;
        break;
  
      case 'End':
        setSelectedTab(tabNodes.length - 1, true);
        flag = true;
        break;
  
      default:
        break;
    }
  
    if (flag) {
      event.stopPropagation();
      event.preventDefault();
    }
  };

  const setSelectedToNextTab = (moveFocus) => {
    let nextIndex = currentIndex + 1;
  
    if (nextIndex >= tabNodes.length) {
      nextIndex = 0;
    }
  
    setSelectedTab(nextIndex, moveFocus);
  };

  const setSelectedToPreviousTab = (moveFocus) => {
    let nextIndex = currentIndex - 1;
  
    if (nextIndex < 0) {
      nextIndex = tabNodes.length - 1;
    }
  
    setSelectedTab(nextIndex, moveFocus);
  };

  const setSelectedTab = (index, moveFocus) => {
    if (index === currentIndex) {
      return;
    }
    currentIndex = index;
  
    for (let i = 0; i < tabNodes.length; i++) {
      hideTabpanel(i);
    }
  
    showTabpanel(index, moveFocus);
  };

  const showTabpanel = (index, moveFocus) => {
    let tabNode = tabNodes[index];
    let panelNode = tabpanelNodes[index];
  
    tabNode.setAttribute('aria-selected', 'true');
    tabNode.removeAttribute('tabindex');
    tabNode.classList.add('bux-hero__tab--active');
  
    if (panelNode) {
      panelNode.classList.add('showing');
    }
  
    if (moveFocus) {
      tabNode.focus();
    }
  };

  const hideTabpanel = (index) => {
    let tabNode = tabNodes[index];
    let panelNode = tabpanelNodes[index];
  
    tabNode.setAttribute('aria-selected', 'false');
    tabNode.setAttribute('tabindex', '-1');
    tabNode.classList.remove('bux-hero__tab--active');
  
    if (panelNode) {
      panelNode.classList.remove('showing');
    }
  };

  const handleTabFocus = () => {
    liveRegionNode.setAttribute('aria-live', 'polite');
  };

  tablistNode.addEventListener('focusin', handleTabFocus);

  for (let i = 0; i < nodes.length; i++) {
    let n = nodes[i];

    tabNodes.push(n);

    n.addEventListener('keydown', handleTabKeydown);
    n.addEventListener('click', handleSlidepickerClick);

    let tabpanelNode = document.getElementById(n.getAttribute('aria-controls'));
    if (tabpanelNode) {
      tabpanelNodes.push(tabpanelNode);
    } else {
      tabpanelNodes.push(null);
    }

    if (i === 0) {
      n.removeAttribute("tabindex");
    }
  }
});

// video controls
const heroPauseButtons = Array.from(document.querySelectorAll(".bux-hero__video-button"));

heroPauseButtons.forEach((pauseButton) => {
  const toggleVideo = () => {
    let buttonText = pauseButton.querySelector("span");
    const heroVideo = document.querySelector("video");

    if (heroVideo.paused) {
      heroVideo.play();
      buttonText.innerHTML = "Pause video";  
      pauseButton.classList.remove('bux-hero__video-play');
    } else {
      heroVideo.pause();
      buttonText.innerHTML = "Play video";
      pauseButton.classList.add('bux-hero__video-play');
    }
  }
  
  pauseButton.addEventListener("click", toggleVideo);
});